<template>
    <div id="contenedor-main-listado">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoFuentesFinancieras="listadoFuentesFinancieras"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoFuentesFinancieras="listadoFuentesFinancieras"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoFuentesFinancieras',
  props: {
    listadoFuentesFinancieras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
